/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Commission_Customer_Status_ActiveInputs */



/**
* | output |
* | --- |
* | "Active" |
*
* @param {Partner_Commission_Customer_Status_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_commission_customer_status_active = /** @type {((inputs?: Partner_Commission_Customer_Status_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Commission_Customer_Status_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktiv")
	return /** @type {LocalizedString} */ ("Active")
});